import { render, staticRenderFns } from "./MediaNews.vue?vue&type=template&id=64349b70&scoped=true"
import script from "./MediaNews.vue?vue&type=script&lang=js"
export * from "./MediaNews.vue?vue&type=script&lang=js"
import style0 from "./MediaNews.vue?vue&type=style&index=0&id=64349b70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64349b70",
  null
  
)

export default component.exports